import { FC, useState } from 'react'
import Dotdotdot from 'react-dotdotdot'
import { ReadMoreProps as Props } from './types'
import { useTranslation } from 'react-i18next'
import styles from './ReadMore.module.scss'

const ReadMore: FC<Props> = ({ text }) => {
  // i18n
  const { t } = useTranslation('readMore')

  // Local state
  const [open, setOpen] = useState<boolean>(false)

  return (
    <div className={styles['readmore']}>
      {!open ? <Dotdotdot clamp={6}>{text}</Dotdotdot> : <div>{text}</div>}

      <div className="has-text-centered">
        <button onClick={() => setOpen(!open)} className="is-clickable is-underlined">
          {open ? t('readLess', 'Lees minder') : t('readMore', 'Lees meer')}
        </button>
      </div>
    </div>
  )
}

export default ReadMore
